let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6BHMm")).then(() => parcelRequire('ee5d3'));